import * as bpAutocompleteActions from './actions';
import reducer from './reducers';
import bpAutocompleteTypes from './types';

export { bpAutocompleteActions, bpAutocompleteTypes };

export default reducer;
